export type ProjectType = 'newsletter' | 'hey_genius' | 'new_video';

export type MediaPlayerTimedEvent = {
  time: number; // legacy
  current_time: number;
  watch_time: number;
  skipped_time: number;
  duration: number;
  completion_rate: number;
  playback_rate: number;
};

export enum MediaAnalyticsEvents {
  // MediaPlayerStartedEvent = 'media_player_start',
  // MediaPlayerReplayEvent = 'media_player_replay',
  MediaPlayerImpressionEvent = 'media_player_impression',
  MediaPlayerPlayEvent = 'media_player_play',
  MediaPlayerSeekEvent = 'media_player_seek',
  MediaPlayerPausedEvent = 'media_player_pause',
  MediaPlayerResumedEvent = 'media_player_resume',
  MediaPlayerCompletedEvent = 'media_player_ended',
  MediaPlayerHeartbeatEvent = 'media_player_heartbeat',
}

export type MediaEventsWithProperties = {
  [MediaAnalyticsEvents.MediaPlayerPausedEvent]: MediaPlayerTimedEvent;
  [MediaAnalyticsEvents.MediaPlayerSeekEvent]: MediaPlayerTimedEvent & {
    seek_start: number;
    seek_end: number;
  };
  [MediaAnalyticsEvents.MediaPlayerResumedEvent]: MediaPlayerTimedEvent;
  [MediaAnalyticsEvents.MediaPlayerCompletedEvent]: MediaPlayerTimedEvent;
  [MediaAnalyticsEvents.MediaPlayerPlayEvent]: MediaPlayerTimedEvent;
  [MediaAnalyticsEvents.MediaPlayerHeartbeatEvent]: MediaPlayerTimedEvent;
};
